import { createStyles, makeStyles } from '@hawkins/styles';
export function accordionDetailsStyles(theme) {
    var hawkinsVariables = theme.hawkinsVariables;
    return createStyles({
        /** Class name of the root element. */
        root: {
            padding: "".concat(hawkinsVariables.spacings.space1, " ").concat(hawkinsVariables.spacings.space3),
        },
        /** Class name of the root element when the component has no padding. */
        rootNoPadding: {
            padding: 0,
        },
    });
}
export var useAccordionDetailsStyles = makeStyles(accordionDetailsStyles, { name: 'Hawkins-AccordionDetails' });
